import axios from "axios";
import api from "./api"

export const SearchAPI = async(query) => {
  let from = query.from;
  let search = query.query.simple_query_string.query
  const res = axios.get(`${api}?from=${from}&query=${search}`).then(response => {
    return response;    
  }).catch(function (error) {
    console.log(error);
    return error;
  });

  return await res;
};


